import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";
import { IVisitScheduleInputValues } from "../../../../types/sheduleOnterface";

const initialState: any = {
  scheduleData: null,
  visitReportsCount: null,
  contract: null,
  limit: JSON.parse(localStorage.getItem("pageLimit") as string) || 10,
  page: 1,
  visitScheduleInputValues: {
    contract: null,
    merchs: null,
    regions: null,
    statuses: null,
    areas: null,
    chains: null,
    address: null,
  },
  isOpenHistory: false,
  isFilteredByTrainee: false,
};

export const visitScheduleSlice = createSlice({
  name: "visitSchedule",
  initialState,
  reducers: {
    reducerVisitScheduleData: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
      state.scheduleData = action.payload.data.data.data || [];
      state.visitReportsCount = action.payload.data.data.count;
      state.contract = action.payload.data.contract;
      state.limit = action.payload.limit;
      state.page = action.payload.page;
    },
    reducerGetScheduleFilters: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
      state.scheduleFilters = action.payload.data;

      state.scheduleContractOptions = action.payload.data[0]?.contracts
        ?.map((option: { id: number, name: string }) => ({
          value: option.id >= 0 ? option.id : option,
          label: option.name || option,
        }))
        ?.sort((a: { value: number, label: string }, b: { value: number, label: string }) => a.label.localeCompare(b.label));
      state.scheduleRegionsOptions = action.payload.data[0].regions.map((option: any) => ({
        value: option.id >= 0 ? option.id : option,
        label: option.name || option,
      }));;
      state.scheduleChainsOptions = action.payload.data[0].chains.map((option: any) => ({
        value: option.id >= 0 ? option.id : option,
        label: option.name || option,
      }));;
      state.scheduleMerchsOptions = action.payload.data[0].merchs.map((option: any) => ({
        value: option.id >= 0 ? option.id : option,
        label: option.name || option,
      }));;
      state.scheduleAreasOptions = action.payload.data[0].areas.map((option: any) => ({
        value: option.id >= 0 ? option.id : option,
        label: option.name || option,
      }));;
    },
    reducerVisitScheduleInputValues: (
      state: Draft<{ visitScheduleInputValues: IVisitScheduleInputValues }>,
      action: PayloadAction<IVisitScheduleInputValues>
    ) => {
      state.visitScheduleInputValues = action.payload;
    },
    reducerVisitScheduleInputValuesMultiSelect: (
      state: Draft<{ visitScheduleInputValues: IVisitScheduleInputValues }>,
      action: PayloadAction<IVisitScheduleInputValues>
    ) => {
      const values = Object.values(action.payload)[0];
      const isArrayEmpty = Array.isArray(values) && values.length === 0;
      state.visitScheduleInputValues = { ...state.visitScheduleInputValues, ...(!isArrayEmpty ? action.payload : { [Object.keys(action.payload)[0]]: null }) };
    },
    reducerVisitScheduleHistory: (
      state: Draft<{ isOpenHistory: boolean }>,
      action: PayloadAction<boolean>
    ) => {
      state.isOpenHistory = action.payload;
    },
    reducerVisitSchedulaStatus: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
      state.scheduleStatus = action?.payload;
    },
    reducerVisitScheduleTrainee: (
      state: Draft<{ isFilteredByTrainee: boolean }>,
      action: PayloadAction<boolean>
    ) => {
      state.isFilteredByTrainee = action?.payload;
    },
  },
});

export const {
  reducerVisitScheduleInputValuesMultiSelect,
  reducerVisitScheduleInputValues,
  reducerVisitScheduleTrainee,
  reducerVisitScheduleHistory,
  reducerVisitSchedulaStatus,
  reducerGetScheduleFilters,
  reducerVisitScheduleData,
} = visitScheduleSlice.actions;

export default visitScheduleSlice.reducer;
